import React, { useEffect, useState, useContext } from "react";
import { isMobile } from "react-device-detect";
import useTranslation from "../../hooks/useTranslation";
import { FloatingDialog } from "../../components/atoms/FloatingDialog";
import SimpleButton from "../NSButton/Types/SimpleButton";

const DialogDownNotes = ({
  icon,
  text,
  callbackConfirm,
  callbackCancel,
  status,
}) => {
  const T = useTranslation();
  const [isOpen, setIsOpen] = useState(status);
  const [notes, setNotes] = useState();

  const handlerClose = () => {
    setNotes("");
    if (callbackCancel) {
      callbackCancel();
    }
  };

  const handlerChangeText = (e) => {
    setNotes(e.target.value);
  };

  const handlerSave = () => {
    if (callbackConfirm) {
      callbackConfirm(notes);
    }
  };

  useEffect(() => {}, []);

  useEffect(() => {
    setIsOpen(status);
  }, [status]);

  return (
    <>
      <FloatingDialog
        isOpen={isOpen}
        onClose={handlerClose}
        variant={"bottom"}
        headerIcon={icon}
        headerText={text}
      >
        <div className="w-full">
          <div className="w-[100%] px-4  pb-2 max-h-[70vh] flex flex-col items-start bg-white ">
            <div className="flex p-4  min-h-[40vh] flex-col w-full h-full items-start justify-start  overflow-auto">
              <textarea
                style={{ resize: "none" }}
                className="w-full p-4"
                autoComplete="off"
                autoFocus
                placeholder="Escribe algo en las notas."
                rows={22}
                onChange={handlerChangeText}
                value={notes}
              ></textarea>
            </div>
          </div>
          <div
            style={{
              marginBottom: isMobile ? "60px" : "0px",
              borderTop: "1px solid #e5e5e5",
            }}
            className=" flex pt-4 justify-center items-center w-full"
          >
            <SimpleButton
              disabled={!notes}
              text={T("saveAndReturn")}
              onClick={handlerSave}
            />
          </div>
        </div>
      </FloatingDialog>
    </>
  );
};

export default DialogDownNotes;
